<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
    <title v-if="title">{{ title }}</title>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M16.254 15.647c-.914.871-2.001 1.307-3.258 1.307-1.206 0-2.268-.413-3.184-1.24-.97-.874-1.455-1.955-1.455-3.244 0-1.271.467-2.334 1.398-3.188.898-.827 1.971-1.24 3.22-1.24 1.314 0 2.417.432 3.31 1.299.894.867 1.34 1.919 1.34 3.157 0 1.228-.456 2.278-1.371 3.15zM12.952 0C9.45 0 6.439 1.16 3.919 3.479 1.307 5.877 0 8.859 0 12.42c0 3.617 1.36 6.65 4.079 9.1C6.65 23.842 9.627 25 13.011 25c3.527 0 6.575-1.22 9.14-3.665C24.717 18.892 26 15.946 26 12.5c0-3.472-1.252-6.423-3.76-8.854C19.736 1.216 16.639 0 12.953 0z"
    />
  </svg>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
});
</script>
